// src/components/EmptyStateIllustration.jsx
export default function EmptyStateIllustration({ size = 120, tone = "sprout" }) {
  const color = tone === "bell" ? "var(--info)" : tone === "reply" ? "var(--brand)" : "var(--brand)";
  const accent = tone === "bell" ? "color-mix(in oklab, var(--info) 26%, transparent)" : "color-mix(in oklab, var(--brand) 26%, transparent)";
  const leaf = tone === "reply" ? "color-mix(in oklab, var(--brand) 70%, white)" : "color-mix(in oklab, var(--brand) 55%, white)";
  return (
    <div className="mx-auto mb-3 flex items-center justify-center" aria-hidden="true">
      <svg
        width={size}
        height={size}
        viewBox="0 0 140 140"
        fill="none"
        role="presentation"
      >
        <defs>
          <linearGradient id="sprout-gradient" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={accent} />
            <stop offset="100%" stopColor="transparent" />
          </linearGradient>
        </defs>
        <rect x="8" y="18" width="124" height="104" rx="16" fill="url(#sprout-gradient)" />
        <circle cx="70" cy="88" r="26" fill={accent} />
        <path
          d="M68 94c-6-2-10-8-10-15 0-9 7-16 16-16 3 0 6 1 9 3"
          stroke={color}
          strokeWidth="5"
          strokeLinecap="round"
        />
        <path
          d="M70 78c0-10 4-18 12-22"
          stroke={color}
          strokeWidth="5"
          strokeLinecap="round"
        />
        <path
          d="M72 62c-10-1-18-6-20-14 7-1 15 1 20 6"
          fill={leaf}
          stroke={color}
          strokeWidth="3"
          strokeLinecap="round"
        />
        {tone === "bell" ? (
          <>
            <path
              d="M92 56c0 12-6 18-6 24H54c0-6-6-12-6-24 0-10 8-18 20-20-.4-3 2-5 5-5 3 0 5 2 5 5 12 2 20 10 20 20Z"
              fill={color}
              opacity=".18"
            />
            <path
              d="M92 56c0 12-6 18-6 24H54c0-6-6-12-6-24 0-10 8-18 20-20-.4-3 2-5 5-5 3 0 5 2 5 5 12 2 20 10 20 20Z"
              stroke={color}
              strokeWidth="3"
              strokeLinecap="round"
            />
            <circle cx="70" cy="86" r="6" fill={leaf} />
          </>
        ) : null}
      </svg>
    </div>
  );
}
